import React from 'react';
import { User } from 'lucide-react';

const ProfileIndicator = ({ score, onClick }) => {
  const pct = Math.round((score || 0) * 100);

  return (
    <button onClick={onClick} style={styles.container} title="Voir votre profil">
      <User size={14} style={{ color: 'var(--text-secondary)' }} />
      <span style={styles.label}>Profil : {pct}%</span>
      <div style={styles.barBg}>
        <div style={{ ...styles.barFill, width: `${pct}%` }} />
      </div>
    </button>
  );
};

const styles = {
  container: {
    display: 'flex', alignItems: 'center', gap: 8, padding: '10px 16px',
    background: 'none', border: 'none', borderTop: '1px solid var(--history-border)',
    cursor: 'pointer', width: '100%', fontSize: 12, color: 'var(--text-secondary)',
  },
  label: { whiteSpace: 'nowrap', fontWeight: 500 },
  barBg: {
    flex: 1, height: 4, background: 'var(--profile-bar)', borderRadius: 2, overflow: 'hidden',
  },
  barFill: {
    height: '100%', background: 'var(--profile-fill)', borderRadius: 2, transition: 'width 0.3s',
  },
};

export default ProfileIndicator;
